/**
 * Load the source for Raw Trade Summary WebComponent, which is used in the Raw Trade Summary panel
 *
 * @param document - the DOM document, injected rather than pulled via Angular just to keep this code vanilla
 */
export function loadRawTradeSummaryScript(document: Document) {
  const now = Date.now()
  const jsPath = '/plugin/raw-trade-summary/raw-trade-summary.js'
  const script = document.getElementById('rawTradeSummaryUrl')
  script?.setAttribute('src', `${jsPath}?v=${now}`)
}
